import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

export const Footer: React.FC = () => {
	return (
		<Box sx={{ textAlign: 'center', font: 'body', mt: 16, color: '#403A49' }}>
			<Text size="small" data-qa="ppmu-modal-footer-text">
				<Translate value="corgi.co.ppmu.modal.footer_text" />
			</Text>
		</Box>
	);
};
